import React from "react";
import { ActivityIndicator, View } from "react-native";
import styles from "../styles";
import theme from "../theme";

const LoadingOverlay = () => (
	<View style={styles.layout.loadingOverlay} nativeID="laco-app-loading-overlay">
		<View style={styles.layout.loadingBox}>
			<ActivityIndicator size="large" color={theme.colors.orange} />
		</View>
	</View>
);

export default LoadingOverlay;
